import { commonUtil } from '@/util'
const request = {}

request.createRequest = function (params) {
  return {
    productId: params.productId,
    ecGoodsId: params.ecGoodsId
  }
}
export default { request }
